<div class="report-info">
  <div class="map" [ngClass]="{'spinner' : loadingData() && !report}">
    @if (reportDataFull.length) {
      <frmg-map [reportData]="reportDataFull" (elementClick)="openAnalysisModalById($event)" [skippClickOnNotPoints]="true"/>
    }
  </div>
  <div id="chart">
    <div class="chart-header">
      <div class="chart-title">Exposure {{currentChart === 'line' ? 'Profile' : 'Distribution'}}</div>
      <div class="chart-switch">
        <inline-svg src="Chart.svg" className="Chart-icon"
          [ngClass]="currentChart === 'bar' ? 'active' : ''"
          hoverColor="#85BBF3"
          [color]="currentChart !== 'bar' ? '#7F8F98' : '#85BBF3'"
          activeColor="#85BBF3"
          (click)="selectChart('bar')"
        ></inline-svg>
        <inline-svg src="line-chart.svg" className="line-chart-icon"
          [ngClass]="currentChart === 'line' ? 'active' : ''"
          hoverColor="#85BBF3"
          [color]="currentChart !== 'line' ? '#7F8F98' : '#85BBF3'"
          activeColor="#85BBF3"
          (click)="selectChart('line')"
        ></inline-svg>
      </div>
    </div>
    <div class="horizontal-separator"></div>
    <div class="chart-container">
      @if (chartReady && currentChart === 'line') {
        <apx-chart
          [series]="chartOptions.series"
          [chart]="chartOptions.chart"
          [labels]="chartOptions.labels"
          [plotOptions]="chartOptions.plotOptions"
          [legend]="chartOptions.legend"
          [colors]="chartOptions.colors"
          [fill]="chartOptions.fill"
          [tooltip]="chartOptions.tooltip"
          [stroke]="chartOptions.stroke"
          [dataLabels]="chartOptions.dataLabels"
          [yaxis]="chartOptions.yaxis"
          [xaxis]="chartOptions.xaxis"
          [noData]="chartOptions.noData"
          [grid]="chartOptions.grid"
        ></apx-chart>
      }
      @if (histogramReady && currentChart === 'bar' ) {
        <apx-chart
          [series]="histogramOptions.series"
          [chart]="histogramOptions.chart"
          [labels]="histogramOptions.labels"
          [plotOptions]="histogramOptions.plotOptions"
          [legend]="histogramOptions.legend"
          [colors]="histogramOptions.colors"
          [fill]="histogramOptions.fill"
          [tooltip]="histogramOptions.tooltip"
          [stroke]="histogramOptions.stroke"
          [dataLabels]="histogramOptions.dataLabels"
          [yaxis]="histogramOptions.yaxis"
          [xaxis]="histogramOptions.xaxis"
          [noData]="histogramOptions.noData"
          [grid]="histogramOptions.grid"
        ></apx-chart>
      }
    </div>
  </div>
</div>

<div class="download-table" [ngClass]="{'spinner' : loadingData()}">
  <div class="table-header">
    <span>Segments</span>
    <div class="header-control">
      <!--            <mat-form-field appearance="outline">-->
      <!--                <div class="icon icon-search" matPrefix></div>-->
      <!--                <input matInput [formControl]="areaSearchCtrl" placeholder="Search by areas">-->
    <!--            </mat-form-field>-->
    <!--            <span class="icon icon-columns"-->
    <!--                  (click)="toggleColumnMenu()"-->
  <!--                  [ngClass]="{'menu-open': columnMenu}"></span>-->
  @if (columnMenu) {
    <div class="column-menu-panel">
      <div class="column-header">
        <div>
          <span class="column-header-title">Configure columns</span>
          <span class="icon icon-small-close" (click)="toggleColumnMenu()"></span>
        </div>
        <div class="horizontal-separator"></div>
      </div>
      <div class="columns-body" (click)="$event.stopPropagation()" cdkDropListGroup>
        <div class="columns-shown"
          cdkDropList
          [cdkDropListData]="displayedColumnsDrag"
          (cdkDropListDropped)="drop($event)">
          <span class="list-title">
            Shown attributes
          </span>
          @for (column of displayedColumnsDrag; track column; let i = $index) {
            <div class="list-column" cdkDrag
              cdkDragPreviewClass="list-column">
              <span class="icon icon-Drag"></span>
              <span class="cdkDrag">{{ column }} </span>
              <mat-slide-toggle
                [checked]="true"
                [disabled]="i == 1 || i == 2"
                (change)="toggleColumn(i, column, true)">
              </mat-slide-toggle>
            </div>
          }
        </div>
        <div class="columns-hidden">
          <span class="list-title">
            Hidden attributes
          </span>
          @for (column of hiddenColumns; track column; let i = $index) {
            <div class="list-column">
              <span class="icon icon-Drag"></span>
              <span class="cdkDrag">{{ column }} </span>
              <mat-slide-toggle
                [checked]="false"
                (change)="toggleColumn(i, column, false)">
              </mat-slide-toggle>
            </div>
          }
        </div>
      </div>
      <div class="column-controls">
      </div>
    </div>
  }
</div>
</div>
<div class="table-container">
  <table mat-table [dataSource]="reportData" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)"
    [matSortDisabled]="loadingData()" matSortDisableClear>
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>Segment Name</mat-header-cell>
      <mat-cell *matCellDef="let element"
        [matTooltip]="element.name">
        <div class="area-name-cell">
          <!--                        <span>-->
          <!--                            <div [ngClass]="getAreaIconType(element.area)"></div>-->
          <!--                            <div>{{ truncate(element.area.properties.address?.name || element.area.properties.address?.display_name, 50) }}</div>-->
        <!--                        </span>-->
        <span> {{segmentLength(element)}}  </span>
      </div>

      <!--                    <span class="icon icon-focus" (click)="focusOn(element, $event)"></span>-->
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="avg_exposure_value">
    <mat-header-cell *matHeaderCellDef >Avg. exposure</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.geometry_values.Exposure?.toFixed(0) }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="risk_percentage">
    <mat-header-cell *matHeaderCellDef>Risk percentage</mat-header-cell>
    <mat-cell *matCellDef="let element">
      <frmg-histogram-bar [data]="element.area.properties.histogram_data.data.raw_counts"></frmg-histogram-bar>
    </mat-cell>
  </ng-container>
  <ng-container matColumnDef="avg_input_point_value">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Exposure</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.area.properties.avg_input_point_value }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="percentile">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Total Annual Burn Frequency (%)</mat-header-cell>
    <mat-cell *matCellDef="let element">{{element.area.properties.percentile_category}} ({{ element.area.properties.percentile?.toFixed(0)  }}%)</mat-cell>
  </ng-container>
  <ng-container matColumnDef="nearest_value_actual">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Nearest Exposure (value)</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.area.properties.nearest_value_actual }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="lowest_value_actual">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Exposure Lowest</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.area.properties.lowest_value_actual }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="highest_value_actual">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Exposure Highest</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.area.properties.highest_value_actual }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="distance">
    <mat-header-cell *matHeaderCellDef>Distance to risk</mat-header-cell>
    <mat-cell *matCellDef="let element">{{ element.area.properties.distance || 0 | round }}m</mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" ></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns;"
    [style.border-color]="colors[0]"
    (click)="openAnalysisModal(row)"
  (mouseenter)="highlightOnHover(row)"></mat-row>
</table>
</div>
<!--    <mat-divider></mat-divider>-->
<!--    <div class="table-footer">Showing {{totalElements}} out of {{totalElements}} </div>-->

</div>

<ng-template #summaryCard let-value="value" let-title="title" >
  <div class="summary-card">
    <div class="card-info">
      <p class="card-reading" [innerHTML]="value"></p>
      <p class="card-title">{{ title | translate }}</p>
    </div>
  </div>
</ng-template>
